import { render, staticRenderFns } from "./AppointmentBookingSection.vue?vue&type=template&id=3846928a&scoped=true"
import script from "./AppointmentBookingSection.vue?vue&type=script&lang=js"
export * from "./AppointmentBookingSection.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBookingSection.vue?vue&type=style&index=0&id=3846928a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846928a",
  null
  
)

export default component.exports